import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, FileTextIcon, FileIcon, ShieldCheckIcon, PenToolIcon, VoteIcon, ArrowRightIcon } from 'lucide-react';
export function ServicesSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const services = [{
    title: 'Passports',
    description: 'New applications, renewals, and replacements for Lebanese passports.',
    icon: BookOpenIcon
  }, {
    title: 'Visas',
    description: 'Tourist, business, and transit visas for traveling to Lebanon.',
    icon: FileTextIcon
  }, {
    title: 'Civil Status Documents',
    description: 'Registration and issuance of birth, marriage, and death certificates.',
    icon: FileIcon
  }, {
    title: 'Legalization & Authentication',
    description: 'Document attestation, certification, and apostille services.',
    icon: ShieldCheckIcon
  }, {
    title: 'Power of Attorney',
    description: 'Drafting and legalizing general and special authorization documents.',
    icon: PenToolIcon
  }, {
    title: 'Electoral Registration',
    description: 'Voter registration and updates for Lebanese nationals residing abroad.',
    icon: VoteIcon
  }];
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="services" className="py-24 bg-muted/40 border-y border-border/50" ref={ref} data-id="element-205">
      <div className="container mx-auto px-4" data-id="element-206">
        <motion.div className="text-center mb-20 max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-207">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-foreground mb-6" data-id="element-208">
            Consular Services
          </h2>
          <div className="w-24 h-1.5 bg-[#006233] mx-auto rounded-full mb-8" data-id="element-209"></div>
          <p className="text-xl text-muted-foreground leading-relaxed" data-id="element-210">
            We provide a comprehensive range of consular services to the
            Lebanese community in New South Wales and surrounding areas.
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto" initial="hidden" animate={isInView ? 'visible' : 'hidden'} variants={containerVariants} data-id="element-211">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={index} variants={cardVariants} className="bg-card border border-border/60 rounded-2xl p-10 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group cursor-pointer flex flex-col items-center text-center h-full relative overflow-hidden" data-id="element-212">
                <div className="absolute top-0 left-0 w-full h-1 bg-[#006233] opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-213"></div>

                <div className="w-20 h-20 bg-emerald-50 dark:bg-emerald-950/30 rounded-full flex items-center justify-center mb-8 group-hover:bg-[#006233] transition-colors duration-300" data-id="element-214">
                  <Icon className="w-10 h-10 text-[#006233] dark:text-emerald-500 group-hover:text-white transition-colors duration-300" data-id="element-215" />
                </div>

                <h3 className="text-2xl font-bold text-foreground mb-4 group-hover:text-[#006233] transition-colors duration-300" data-id="element-216">
                  {service.title}
                </h3>

                <p className="text-muted-foreground text-lg flex-1 mb-6" data-id="element-217">
                  {service.description}
                </p>

                <div className="mt-auto flex items-center text-sm font-bold text-muted-foreground group-hover:text-[#006233] transition-colors" data-id="element-218">
                  View Details{' '}
                  <ArrowRightIcon className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-219" />
                </div>
              </motion.div>;
        })}
        </motion.div>

        <motion.div className="mt-20 text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} data-id="element-220">
          <button className="px-10 py-4 bg-[#006233] hover:bg-emerald-800 text-white font-bold text-lg rounded-lg shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300" data-id="element-221">
            View All Requirements & Forms
          </button>
        </motion.div>
      </div>
    </section>;
}